import { InputHTMLAttributes } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

interface SearchFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  shortcut?: string;
  className?: string;
}

export const SearchField = ({
  shortcut = "⌘K",
  className = "",
  placeholder = "Rechercher une ressource…",
  ...props
}: SearchFieldProps) => {
  return (
    <div
      className={`flex items-center gap-2.75 h-control pl-4 pr-2.5 rounded-pill bg-surface-field border border-line-search focus-within:border-ink app:bg-[var(--search-surface)] app:border-field-edge app:focus-within:border-field-focus-edge app:focus-within:shadow-field-focus modal:bg-[var(--search-modal-surface)] modal:border-field-edge-modal modal:focus-within:border-field-focus-edge-modal modal:focus-within:shadow-field-focus has-[:disabled]:[opacity:var(--search-disabled-opacity)] has-[:disabled]:cursor-not-allowed ${className}`}
    >
      <MagnifyingGlassIcon className="w-4 h-4 shrink-0 text-ink-meta" aria-hidden="true" />
      <input
        type="search"
        placeholder={placeholder}
        className={`flex-1 min-w-0 bg-transparent border-none font-ui text-control-lg font-500 text-ink placeholder:text-[color:var(--placeholder-ink,rgb(var(--ink-meta)))] disabled:text-disabled-fg disabled:cursor-not-allowed !bg-transparent !shadow-none outline-none focus:outline-none focus-visible:outline-none`}
        {...props}
      />
      {shortcut && (
        <span className="shrink-0 px-2 py-1 rounded-lg bg-surface-raised font-numeric text-kbd text-ink-kbd">
          {shortcut}
        </span>
      )}
    </div>
  );
};